import React from "react";
import { Box, Typography, Avatar, Button } from "@mui/material";

const UserProfileCard = ({ name = "Nome", role = "Usuário", color = "#4680FF", onClick }) => {

    return (
        <Button
            sx={{
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: 2,
            }}
            >
            {/* Text Section */}
            <Box sx={{ display: { xs: 'none', md: 'block' }}}>
                <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "rgba(106, 106, 106, 1)" }}
                >
                {name}
                </Typography>
                <Typography
                variant="body2"
                sx={{ color: "rgba(177, 177, 177, 1)" }}
                >
                {role}
                </Typography>
            </Box>

            {/* Avatar Section */}
            <Avatar
                sx={{
                bgcolor: color,
                width: 40,
                height: 40,
                fontWeight: "bold",
                }}
                onClick={onClick}
            >
                {name.charAt(0).toUpperCase()}
            </Avatar>
        </Button>
    );
};

export default UserProfileCard;